module.exports = "/_next/static/images/AIAndML-sm-be44a5191ae00c359f14514dc3c1acac.webp";